module.exports = __webpack_public_path__ + "static/media/foster-together-project.e15a7282.png";